import { getLocation } from "@faire/web--source/common/globals/getLocation";
import { parsePath } from "history";

import { IRoutingContext, NavigationType } from "./types";

export function getShouldUseSoftNavigation(
  nav: NavigationType | undefined,
  routingContext: IRoutingContext,
  toStr: string
): boolean {
  if (nav === "soft") {
    return true;
  } else if (nav === "shallow") {
    return false;
  } else if (routingContext.getShouldUseSoftNavigation) {
    const currentLocation = getLocation();
    return routingContext.getShouldUseSoftNavigation(
      currentLocation ?? { pathname: "", search: "" },
      parsePath(toStr)
    );
  } else {
    return true;
  }
}
